/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const leaseCalculatorNodes = document.querySelectorAll('.lease-calculator');

if (leaseCalculatorNodes.length > 0) {
    import(/* webpackChunkName: "LeaseCalculator" */ './components/LeaseCalculator').then(({default: LeaseCalculator}) => {
        [...leaseCalculatorNodes].forEach((node) => render(<LeaseCalculator {...parseDataToProps(node.dataset)} />, node));
    });
}
